<template>
  <div>
    <CaseTab :predmet_info="predmet_info" :current_tab="'Sudionici'" :mapped_permission="mapped_case_permission" />
    <div class="case-spisi">
      <div class="upload-dokumenta-button" @click="addEditLogic(false)">
        {{ $t("page_2.page_2_2.add_outside") }}
        <div class="upload-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <g>
              <g>
                <path fill="#fff"
                  d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="spisi-left sudionici-left">
        <!-- Close case-folders-line -->
        <div class="opening-folder opening-folder-sudionici">
          <div class="open-folder-line">
            <div class="open-folder-line-left switch-sudionici-wrapp">
              <label class="switch">
                <input type="checkbox" v-model="is_editable_sort">
                <span class="slider round"></span>

              </label>
              <span class="status-switch">{{ edit_status }}</span>

            </div>
            <div class="open-folder-line-right">
              <div class="sudionici-dropdown">
                {{ $t("page_2.page_2_2.f1") }}:
                <select class="drop-filter" v-model="selected_uloga" @change="filterByUloga()" id="search-group"
                  :disabled="is_editable_sort">
                  <option value="all">{{ $t("page_2.page_2_2.all_f") }}</option>
                  <option v-for="(uloga, key) in uloge" :key="key" :value="uloga">{{ uloga }}</option>
                </select>
                <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
              </div>
              <div class="sudionici-dropdown2">
                {{ $t("page_2.page_2_2.f2") }}:
                <select class="drop-filter" v-model="selected_spis" @change="filterBySpis()" id="search-group" :disabled="is_editable_sort">
                  <option value="all">{{ $t("page_2.page_2_2.all_f") }}</option>
                  <option :value="spis" v-for="(spis, key) in spisi" :key="key">
                    {{ spis.ime }}
                  </option>
                </select>
                <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
              </div>
            </div>
          </div>
          <custom-spinner v-if="loading" />
          <div v-else class="sudionici-main-wrapper">
            <div class="sudionici-row row-title-row">
              <div class="sudionici-column sudionici-column1">
                {{ $t("page_2.page_2_2.table.col_1") }}
                <div class="downarrow"></div>
              </div>
              <div class="sudionici-column sudionici-column2">
                {{ $t("page_2.page_2_2.table.col_2") }}
                <div class="downarrow"></div>
              </div>
              <div class="sudionici-column sudionici-column3">
                {{ $t("page_2.page_2_2.table.col_3") }}
                <div class="downarrow"></div>
              </div>
              <div class="sudionici-column sudionici-column4">{{ $t("page_2.page_2_2.table.col_4") }}</div>
              <div class="sudionici-column sudionici-column5"></div>
              <div class="sudionici-column sudionici-column6"></div>
            </div>
            <draggable class="sudionici-draggable" :sort="is_editable_sort" v-model="final_list_sudionici">
              <div class="sudionici-row" v-for="(person, key) in final_list_sudionici" :key="'10' + key">
                <router-link :to="person.person_type == 1 ? '/osobe/fiz/' + person.uid : '/osobe/prav/' + person.uid"
                  class="sudionici-column sudionici-column1">
                  <div class="edit-menu">
                    <input type="checkbox" />
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  {{ person.name }}
                </router-link>
                <div class="sudionici-column sudionici-column2">{{ person.status }}</div>
                <div class="sudionici-column sudionici-column3">
                  {{ person.role_id }}
                </div>
                <div class="sudionici-column sudionici-column4">
                  <div v-for="(spis, key) in spisi" :key="key">
                    {{ spis.ime }}
                  </div>
                </div>
              </div>
            </draggable>
            <div class="sudionici-row not-editable-sudionici" v-for="(sluzben, key) in final_sluzbene_osobe"
              :key="'50' + key">

              <router-link :to="'/osobe/leg-body/' + sluzben.sluzbena_osoba.uid"
                class="sudionici-column sudionici-column1">
                {{ sluzben.sluzbena_osoba.ime }}
                {{ sluzben.sluzbena_osoba.prezime }}
              </router-link>
              <div class="sudionici-column sudionici-column2">{{ $t("page_2.page_2_2.fix_val_1") }}</div>
              <div class="sudionici-column sudionici-column3">
                <div>
                  {{ sluzben.uloge[0] }}
                </div>
                <v-tooltip right v-if="
                  sluzben.uloge.length >
                  1
                ">
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                    <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
                  </template>
                  <p v-for="(uloga, key) in sluzben.uloge" :key="key">{{ uloga }}</p>
                </v-tooltip>
              </div>
              <div class="sudionici-column sudionici-column4">
                <div v-for="(spis, key) in sluzben.spis" :key="key">
                  {{ spis }}
                </div>
              </div>
            </div>
            <div class="sudionici-row not-editable-sudionici" v-for="(odvjetnik, idx) in final_odvjetnici"
              :key="'60' + idx">

              <router-link :to="'/osobe/law/' + odvjetnik.odvjetnik.uid" class="sudionici-column sudionici-column1">

                {{ odvjetnik.odvjetnik.ime }} {{ odvjetnik.odvjetnik.prezime }}
              </router-link>
              <div class="sudionici-column sudionici-column2">{{ $t("page_2.page_2_2.fix_val_2") }}</div>
              <div class="sudionici-column sudionici-column3">
                {{ odvjetnik.status_odvjetnik_predmet.naziv }}
              </div>
              <div class="sudionici-column sudionici-column4">
                <div v-for="(spis, key) in spisi" :key="key">
                  {{ spis.ime }}
                </div>
              </div>
              <div class="sudionici-column sudionici-column5" v-if="odvjetnik.end_date != null">
                <div>
                  {{ $t('page_2.page_2_2.expiry') }} {{ standardize_date(odvjetnik.end_date) }}
                </div>
              </div>
              <div v-if="odvjetnik.end_date != null" class="oglasna-buttons-wrapper">
                <div class="edit-info add-button add-pen" @click="addEditLogic(true, odvjetnik)"><svg
                    xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                    <g>
                      <g>
                        <path fill="#7b7b8a"
                          d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z">
                        </path>
                      </g>
                    </g>
                  </svg></div>
                <div class="delete-info add-button add-pen" @click="assignDeleteTmpTeamMember(odvjetnik.odvjetnik)"><svg
                    width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z"
                      fill="#70707E" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Close spisi-left -->
      <!-- <div class="spisi-right sudionici-right" v-if="is_right_visible">
        <div class="detalji-spisa section">
          <div class="section-title">
            {{ selected_pers.fullname }}
          </div>
          <div class="edit-detalji-spisa add-button add-pen">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
              <g>
                <g>
                  <path fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                </g>
              </g>
            </svg>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">Status:</div>
                <div class="case-info-item-info">
                  {{ selected_pers.status }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Uloga:</div>
                <div class="case-info-item-info">{{ selected_pers.uloga }}</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">U spisu:</div>
                <div class="case-info-item-info">
                  <span v-for="(sp, key) in selected_pers.popis_spisa" :key="'70' + key" class="tag">{{ sp.ime }}</span>
                </div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">OIB:</div>
              <div class="case-info-item-info">{{ selected_pers.oib }}</div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Adresa:</div>
              <div class="case-info-item-info" style="flex-direction:column;">
                <div v-for="(adr, key) in selected_pers.adresa" :key="'10' + key">{{ adr.adresa + ',' }} {{ adr.post_br
                    + ','
                }}
                  {{ adr.grad + ',' }} {{ adr.drzava }}</div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Tel:</div>
              <div class="case-info-item-info" style="flex-direction:column;">
                <div v-for="(t, key) in selected_pers.tel" :key="'10' + key">{{ t }}</div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Email:</div>
              <div class="case-info-item-info">
                <div v-for="(e, key) in selected_pers.email" :key="'10' + key">{{ e }}</div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Napomena:</div>
              <div class="case-info-item-info">
                {{ selected_pers.napomena }}
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <v-dialog v-model="outside_popup" width="564px">
      <v-card color="universal-vcard">
        <div :class="['universal-vdialog-title', 'archive-title']">
          {{ popup_add_edit_text }}
        </div>
        <v-form ref="form" v-model="form" class="pa-4 pt-6">
          <div class="project-dropdowns clanovi-tima-wrapper vanjski-suradnici-wrapper">
            <form-autocomplete-single v-if="!is_edit" :label="$t('page_2.page_2_3.outside_popup.assign')" type="clanovi_tima" id="clanovi-tima-eventi" ref="vanjski"
              :placeholder="$t('page_2.page_2_3.outside_popup.assign_members')" :items="outside_members"></form-autocomplete-single>
            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
              max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :rules="[rules.date]" :label="$t('page_2.page_2_3.outside_popup.exp_date')" v-model="dateText" readonly
                  append-icon="mdi-calendar" v-bind="attrs" @click="menu1 = !menu1" v-on="on"
                  class="case-date-picker archive-date-picker"></v-text-field>
              </template>
              <v-date-picker :min="cur_date" locale="hr" v-model="selected_user.date" no-title></v-date-picker>
            </v-menu>
          </div>
          <div class="vdialog-buttons-wrapper wrapper-three-buttons">
            <div class="universal-vdialog-button vbutton-secondary" @click="outside_popup = false;"> {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="addTmpTeamMember"> {{popup_add_edit_btn}} </div>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="outside_delete.popup" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title" v-if="outside_delete.user != null">
          {{ $t('page_2.page_2_3.outside_popup.delete_mem') }} <br />{{ outside_delete.user.name }}?
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="outside_delete.popup = false"> {{ $t("repetitive.cancel") }} </div>
          <div class="universal-vdialog-button vbutton-primary" @click="deleteTmpTeamMember()"> {{
            $t("components.calendar.calendar_modal.delete_pop.btn_2")
          }} </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import person from "@/apiCallers/promise_handler_db/person";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import auth from "@/services/auth";
import draggable from "vuedraggable";
import gsap from "gsap";
import { getCaseData, clearCaseData } from "@/router/case/handler"
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import moment from "moment";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import CustomSpinner from '@/components/generalComponents/CustomSpinner.vue';


export default {
  components: { CaseTab, draggable, formAutocompleteSingle, CustomSpinner },
  data() {
    return {
      cur_date : new Date().toISOString(),
      accessToken: "",
      is_edit: false,
      add_edit_text: {
        add: this.$t("page_2.page_2_3.outside_popup.add_text"),
        edit: this.$t("page_2.page_2_3.outside_popup.edit_text")
      },
      add_edit_btn: {
        add: this.$t("repetitive.create"),
        edit: this.$t("repetitive.edit")
      },

      outside_popup: false,
      outside_delete: {
        popup: false,
        user: null
      },
      outside_members: [],
      selected_user: {
        user: null,
        date: ""
      },
      rules: {
        date: v => !!v || this.$t("page_2.page_2_3.outside_popup.add_date"),
      },
      menu1: false,
      form: false,

      selected_pers: {
        fullname: "",
        status: "",
        uloga: "",
        popis_spisa: [],
        oib: "",
        adresa: "",
        tel: "",
        email: "",
        napomena: "",
      },
      predmet_info: { ime_predmeta:'',broj_predmeta: '' },

      final_fiz_ostali: [],
      final_prav_ostali: [],
      final_fiz_stranke: [],
      final_prav_stranke: [],
      final_fiz_protustranke: [],
      final_prav_protustranke: [],

      nadlezna_tijela: [],
      final_nadlezna_tijela: [],

      institucije: [],

      odvjetnici: [],
      final_odvjetnici: [],

      sluzbene_osobe: [],
      final_sluzbene_osobe: [],

      mapped_case_permission: [],

      list_of_sudionici: [],
      final_list_sudionici: [],
      is_editable_sort: false,
      is_list_filled: false,

      spisi: [],
      uloge: [],
      selected_spis: 'all',
      selected_uloga: 'all',
      is_right_visible: false,


      permission: {
        create: true,
        update: true,
        delete: true,
        read: true
      },
      loading:false,
    };
  },
  computed: {
    popup_add_edit_text: function () {
      if (this.is_edit)
        return this.add_edit_text.edit + " " + this.selected_user.user.name;
      else
        return this.add_edit_text.add;
    },
    popup_add_edit_btn: function () {
      if (this.is_edit)
        return this.add_edit_btn.edit;
      else
        return this.add_edit_btn.add;
    },
    edit_status: function () {
      return this.is_editable_sort ? this.$t("page_2.page_2_2.switch_2") : this.$t("page_2.page_2_2.switch_1");
    },
    dateText() {
      return moment(this.selected_user.date).format('DD.MM.yyyy');
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken;
    this.loading=true;
    await getCaseData(this.$route.params.uid).then(async (response) => {
      let all_together = response;
      this.predmet_info = response;
      await osobe.getAllFizLeg().then((resp) => {
        this.outside_members = resp.data.all_pravnici.filter(i => !all_together.predmet_odvjetnik_connector.some(tm => tm.odvjetnik.uid == i.link));
      });

      this.odvjetnici = all_together.predmet_odvjetnik_connector.sort(
      (a, b) => new Date(a.end_date) - new Date(b.end_date)
    );
      this.sluzbene_osobe = all_together.spisi_people;
      this.institucije = all_together.connect_institucija_predmet;
      this.spisi = all_together.spis;

      this.final_fiz_stranke = all_together.connect_fiz_stranka;
      this.final_fiz_ostali = all_together.connect_fiz_ostali;
      this.final_prav_ostali = all_together.prav_connect_ostali;
      this.final_prav_stranke = all_together.prav_connect_stranka;
      this.final_fiz_protustranke = all_together.connect_fiz_protustranka;
      this.final_prav_protustranke = all_together.prav_connect_protustranka;
      this.final_sluzbene_osobe = this.sluzbene_osobe
      this.final_odvjetnici = this.odvjetnici



      if (this.predmet_info.sortable_participants.length > 0) {
        this.list_of_sudionici = this.predmet_info.sortable_participants
      } else {
        this.reverseEngineerIt()
      }
      this.final_list_sudionici = this.list_of_sudionici
      this.findAllUloge();
    })
    .finally(()=>{
      this.loading=false;
    });
    if (
      this.$store.state.logged_in_user == undefined ||
      this.$store.state.logged_in_user == null
    ) {
      await person.getSelf(this.accessToken).then((resp) => {
        this.$store.state.logged_in_user = resp.data;
      });
    }


    // console.log(this.accessToken)
  },
  watch: {
    final_list_sudionici: async function () {
      if (this.is_list_filled && this.is_editable_sort) {
        console.log("Napravila se izmjena", this.list_of_sudionici)
        predmet_hand.updateOrdering(this.$route.params.uid, this.final_list_sudionici)
        await clearCaseData();
      } else {
        this.is_list_filled = true;
      }
    },
    is_editable_sort() {
      if (this.is_editable_sort) {
        this.selected_spis = "all";
        this.selected_uloga = "all";
        this.filterByUloga()
        this.filterBySpis();
        gsap.to(".edit-menu", 0.5, { paddingRight: "20px", display: "block", opacity: 1 });
        gsap.to(".not-editable-sudionici", 0.5, { opacity: 0.3 });

      }
      else {

        gsap.to(".edit-menu", 0.2, { paddingRight: "0px", opacity: 0, display: "none" });
        gsap.to(".not-editable-sudionici", 0.5, { opacity: 1 });
      }
    },
    outside_popup: function () {
      // if(this.outside_popup)
      // this.selected_user.user = this.$refs.vanjski.$data;
      if (!this.is_edit) {
        setTimeout(() => {
          this.selected_user.user = this.$refs.vanjski.$data;
        }, 200)
      }


    }
  },
  methods: {
    addEditLogic(log_val, sel_user = null) {
      if (sel_user != null) {
        this.selected_user.date = sel_user.end_date,
          this.selected_user.user = {
            name: sel_user.odvjetnik.ime + " " + sel_user.odvjetnik.prezime,
            uid: sel_user.odvjetnik.uid
          }
      }
      this.is_edit = log_val;
      this.outside_popup = true;
    },
    deleteTmpTeamMember: async function () {
      await predmet_hand.removeTmpTeamMember(this.$route.params.uid, this.outside_delete.user.uid, this.accessToken).then(() => {
        this.$store.state.is_intentional_reload = true;
        this.$router.go();
      })

    },
    assignDeleteTmpTeamMember: async function (odvj) {
      this.outside_delete.user = {
        name: odvj.ime + " " + odvj.prezime,
        uid: odvj.uid
      }

      this.outside_delete.popup = true;

    },
    standardize_date: function (tmp_date) {
      return moment(tmp_date).format('DD.MM.yyyy');
    },
    addTmpTeamMember: async function () {
      if(this.is_edit)
      {
        await predmet_hand.editTmpTeamMember(this.$route.params.uid, this.selected_user.user.uid, this.selected_user.date).then(() => {
          this.$store.state.is_intentional_reload = true;
          this.$router.go()
        })

      } else{
        await predmet_hand.addTmpTeamMember(this.$route.params.uid, this.selected_user.user.results_final.uid, this.selected_user.date, this.accessToken).then(() => {
          this.$store.state.is_intentional_reload = true;
          this.$router.go()
        })
      }     
    },
    reverseEngineerIt() {
      // primjer objekta
      // {
      //   "uid" : "",
      // "name" : "",
      // "person_type" : "",
      // "status" : "",
      // "role_id" :p.oznake_status.status_name
      // }
      // PERSON TYPE OZNAKE BROJEVA
      // fizičke osobe oznake 1
      // pravne osobe oznake 2

      this.list_of_sudionici = this.final_fiz_stranke.map((p) => ({
        "uid": p.fizicka_osoba.uid,
        "name": p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
        "person_type": 1,
        "status": "Stranka",
        "role_id": p.oznake_status.status_name

      }))

      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_fiz_ostali.map((p) => ({
        "uid": p.fizicka_osoba.uid,
        "name": p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
        "person_type": 1,
        "status": "Drugi sudionik",
        "role_id": p.oznake_status.status_name
      })))
      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_fiz_protustranke.map((p) => ({
        "uid": p.fizicka_osoba.uid,
        "name": p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
        "person_type": 1,
        "status": "Protustranka",
        "role_id": p.oznake_status.status_name
      })))


      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_prav_ostali.map((p) => ({
        "uid": p.pravna_osoba.uid,
        "name": p.pravna_osoba.ime,
        "person_type": 2,
        "status": "Drugi sudionik",
        "role_id": p.oznake_status.status_name
      })))
      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_prav_stranke.map((p) => ({
        "uid": p.pravna_osoba.uid,
        "name": p.pravna_osoba.ime,
        "person_type": 2,
        "status": "Stranka",
        "role_id": p.oznake_status.status_name
      })))
      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_prav_protustranke.map((p) => ({
        "uid": p.pravna_osoba.uid,
        "name": p.pravna_osoba.ime,
        "person_type": 2,
        "status": "Protustranka",
        "role_id": p.oznake_status.status_name
      })))

      this.is_list_filled = true;

    },

    findAllUloge() {
      this.uloge = [];
      this.uloge = this.list_of_sudionici.map((el) => el.role_id)
      this.final_sluzbene_osobe.forEach((el) => this.uloge.push(...el.uloge))
      this.final_odvjetnici.forEach((el) => this.uloge.push(el.status_odvjetnik_predmet.naziv))
      this.uloge = [...new Set(this.uloge)];
    },
    filterByUloga() {
      this.selected_spis = 'all'
      if (this.selected_uloga != 'all') {
        this.final_list_sudionici = this.list_of_sudionici.filter((el) => el.role_id == this.selected_uloga);
        this.final_sluzbene_osobe = this.sluzbene_osobe.filter((el) => el.uloge.includes(this.selected_uloga));
        this.final_odvjetnici = this.odvjetnici.filter((el) => el.status_odvjetnik_predmet.naziv == this.selected_uloga);
      } else {
        this.final_list_sudionici = this.list_of_sudionici
        this.final_sluzbene_osobe = this.sluzbene_osobe
        this.final_odvjetnici = this.odvjetnici
      }

    },
    filterBySpis() {
      this.final_fiz_stranke = this.fiz_stranke
      this.final_prav_stranke = this.prav_stranke
      this.final_fiz_protustranke = this.fiz_protustranke
      this.final_prav_protustranke = this.prav_protustranke
      this.final_sluzbene_osobe = this.sluzbene_osobe
      this.final_odvjetnici = this.odvjetnici

      this.selected_uloga = 'all'
      if (this.selected_spis != 'all') {
        this.final_sluzbene_osobe = [];
        this.osobe = [];
        this.selected_spis.spis_sudionici_connector.forEach((s_o) => this.osobe.push(s_o.sluzbena_osoba.uid));
        this.final_sluzbene_osobe = this.sluzbene_osobe.filter((os) => this.osobe.includes(os.sluzbena_osoba.uid));
      }
      else {
        this.final_sluzbene_osobe = this.sluzbene_osobe
      }
    },
    goToPredmet(nastavak) {
      if (nastavak === "") {
        this.$router.push("/case/" + this.$route.params.uid + "/");
      } else this.$router.push(nastavak);
    },
  },
  mounted() {
    this.selected_user.date = moment(Date.now()).add(1,"day").format("yyyy-MM-DD");
    // console.log(this.$refs);
    // console.log(this.$refs, "got data vanjski");

    // this.selected_user.user = this.$refs.vanjski.$data;
  },
};
</script>

<style>

</style>